import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Salutation, Status } from "../types";

type GetStatusParams = {
	locale?: string;
	portalUid: string;
};

const fetchSalutation = async (locale: string = "en-us", portalUid: string): Promise<Salutation[]> => {
	const response = await apiDal.post("/queries/public/fetch", {
		query: "getSalutation",
		bind: {
			locale: locale.toLowerCase(),
			enterpriseUid: portalUid,
		},
	});

	return response.data.result;
};

export const useGetSalutation = ({ locale, portalUid }: GetStatusParams) => {
	return useQuery<Salutation[]>({
		queryKey: ["getSalutation", locale, portalUid],
		queryFn: () => fetchSalutation(locale, portalUid),
		enabled: !!portalUid,
		initialData: []
	});
};
